import React from 'react';
import { Button } from 'reactstrap';
export const ButtonClose = ({ text, onClick = () => {} }) => {
  return (
    <Button color="danger" data-dismiss="modal" type="button" onClick={onClick}>
      {text}
    </Button>
  );
};
